import { IAppState, TActions } from '../../../common/state';
import { EBuildingCraneType, jq } from '../../../json_query';
import { getParamChangedAction } from './fabrics/multiselect_param_reducer';

type TBuildingCraneTypeChangedActionType = 'filters/building_crane/BUILDING_CRANE_TYPE_CHANGED';
export const IBuildingCraneTypeChangedActionType = 'filters/building_crane/BUILDING_CRANE_TYPE_CHANGED' as TBuildingCraneTypeChangedActionType;

export interface IBuildingCraneTypeChangedAction {
  type: 'filters/building_crane/BUILDING_CRANE_TYPE_CHANGED';
  paramType: EBuildingCraneType;
  value: boolean;
}

export const changeBuildingCrane = getParamChangedAction<EBuildingCraneType, TBuildingCraneTypeChangedActionType>(
  IBuildingCraneTypeChangedActionType,
);

export function buildingCraneTypeReducer(state: IAppState, action: TActions): IAppState {
  switch (action.type) {
    case IBuildingCraneTypeChangedActionType:
      return {
        ...state,
        filters: {
          ...state.filters,
          jsonQuery: action.value
            ? jq(state.filters.jsonQuery).setBuildingCraneType(action.paramType)
            : jq(state.filters.jsonQuery).unsetBuildingCraneType(action.paramType),
        },
      };

    case 'filters/tags/TAG_REMOVED':
      if (action.tag.type === 'advanced-buildingCrane') {
        return {
          ...state,
          filters: {
            ...state.filters,
            jsonQuery: jq(state.filters.jsonQuery).unsetBuildingCraneType(action.tag.value),
          },
        };
      }

      return state;

    case 'filters/tags/ALL_TAGS_REMOVED':
      return {
        ...state,
        filters: {
          ...state.filters,
          jsonQuery: jq(state.filters.jsonQuery).unsetBuildingCraneTypes(),
        },
      };

    default:
      return state;
  }
}
